/**
 * Refus de signer.
 *
 * Accessible a TOUT MOMENT du parcours, y compris apres lecture - un
 * signataire qui ne veut pas signer ne doit pas avoir a franchir des
 * etapes pour le dire.
 *
 * Le motif est facultatif : l'exiger reviendrait a faire pression sur
 * quelqu'un qui exerce un droit.
 */
import { useState } from "react";

import { ApiError, decline } from "../api";
import type { t } from "../i18n";
import { ErrorPanel } from "../components/ErrorPanel";

interface Props {
  token: string;
  L: ReturnType<typeof t>;
  onDeclined: () => void;
  onCancel: () => void;
}

export function DeclineForm({ token, L, onDeclined, onCancel }: Props) {
  const [reason, setReason] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<ApiError | null>(null);

  const submit = async () => {
    setSubmitting(true);
    setError(null);
    try {
      await decline(token, reason.trim());
      onDeclined();
    } catch (e) {
      const err = e instanceof ApiError ? e : new ApiError("server", 0, null);
      if (err.kind === "conflict") {
        onDeclined();
        return;
      }
      setError(err);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section className="card stack">
      <div>
        <h1 className="card__title">{L.declineTitle}</h1>
        <p className="card__lead">{L.declineBody}</p>
      </div>

      <div>
        <label className="field-label" htmlFor="decline-reason">
          {L.declineReason}
        </label>
        <textarea
          id="decline-reason"
          className="textarea"
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          maxLength={500}
        />
      </div>

      {error && <ErrorPanel error={error} L={L} />}

      <div className="actions">
        <button
          type="button"
          className="btn btn--solid-danger"
          onClick={() => void submit()}
          disabled={submitting}
        >
          {L.declineConfirm}
        </button>
        <button type="button" className="btn btn--secondary" onClick={onCancel}>
          {L.declineCancel}
        </button>
      </div>
    </section>
  );
}
